import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";


const Categories = ({ catContent }) => {


  // const catContent = [
  //   { id: 1, icon: "icon-bed", catName: "Hotel" },
  //   { id: 2, icon: "icon-destination", catName: "Tour" },
  //   { id: 4, icon: "icon-ski", catName: "Activity" },
  //   { id: 5, icon: "icon-home", catName: "Holiday Rentals" },
  //   { id: 5, icon: "icon-car", catName: "Car" },
  //   { id: 6, icon: "icon-yatch", catName: " Cruise" },
  //   { id: 7, icon: "icon-tickets", catName: " Flights" },
  // ];
  return (
    <>

      <div className="slider-brand brand-slider" >
        <Swiper
          spaceBetween={30}
          className="overflow-hidden"
          slidesPerView={2} 
          // scrollbar={{
          //   el: ".js-popular-destination-scrollbar",
          //   draggable: true,
          //   autoplay: true,
          // }}
          autoplay={true}
          modules={[Navigation, Autoplay]}
          navigation={{
            nextEl: ".js-destination-next",
            prevEl: ".js-destination-prev",
          }}
          breakpoints={{
            500: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 22,
            },
            1024: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 7,
              spaceBetween: 50,
            },
          }}
        >
          {catContent?.map((item, index) => (
            <SwiperSlide key={item.id}>
              <button
                className=" d-flex flex-column justify-center px-10 py-15 rounded-4 border-light text-16 lh-14 fw-500 col-12"
                style={{
                  height: "140px",
                  width: "160px",
                  alignItems: 'center'
                }}
              >
                <Image
                  src={`${process.env.IMAGE_BASE_URL}/${item.image}`}
                  width={50}
                  height={50}
                  alt="image"
                  className="rounded-4"
                  style={{
                    margin: "auto",
                  }}
                />

                {item.name}
              </button>
            </SwiperSlide>
          ))}
        </Swiper>


        <div className="z-5">
          <button className="section-slider-navbar z-5 -prev flex-center button -dark-3 bg-white shadow-1 size-40 rounded-full sm:d-none js-destination-prev">
            <i className="icon icon-chevron-left text-12" />
          </button>
          <button className="section-slider-navbar2 z-5 -next flex-center button -dark-3 bg-white shadow-1 size-40 rounded-full sm:d-none js-destination-next">
            <i className="icon icon-chevron-right text-12" />
          </button>
        
        </div>
      </div>










    </>
  );
};

export default Categories;
